import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSetRecoilState } from 'recoil'
import { popupManager, popupDataManager } from '@/recoil/popup'
import { VIDEO_POPUP_ID } from '@/components/Popup/config'
import Icon from '@/components/Icon'
import { useTheme } from '@emotion/react'
import { useLocation } from '@reach/router'

import resolveAssetURL from '@/utils/resolveAssetURL'

import {
  Container,
  MediaWrapper,
  Thumbnail,
  Source,
  ContentWrapper,
  Category,
  Title,
  Text,
  IconWrapper
} from './style'

const VideoCard = ({
  media,
  long = false,
  gtm = () => {}
}) => {
  const [status, setStatus] = useState(false)
  const [isImage, setIsImage] = useState(false)
  const videoRef = useRef(null)
  const setPopup = useSetRecoilState(popupManager)
  const setPopupData = useSetRecoilState(popupDataManager)
  const theme = useTheme()
  const location = useLocation()

  const handleClick = () => {
    if(media && media.source){
      if(location.href.indexOf(`#video_${media.title.split(' ').join('_')}`) === -1)
        history.pushState({}, null, location.href+`#video_${media.title.split(' ').join('_')}`)

      gtm('Play video', media.title)
      setPopup(VIDEO_POPUP_ID)
      setPopupData({...media, closeCallback: closeVideoPopup})
    }
  }

  const closeVideoPopup = _ => {
    history.pushState({}, null, location.href.replace(`#video_${media.title.split(' ').join('_')}`, ''))
  }

  useEffect(() => {
    const query = new URLSearchParams(location.search)

    if(location.href.indexOf(`#video_${media.title.split(' ').join('_')}`) > -1)
      handleClick()
  }, [])

  // const checkIsImage = (url) => (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url))

  return (
    <Container>
      <MediaWrapper className={ `${long ? 'long' : ''}` }>
        <Thumbnail isThumbnail={!!media.source} loading='lazy' onClick={ handleClick } src={ resolveAssetURL(media.thumb) } alt={ media.thumbAlt } className={ `${status && 'hidden'}` } />
        { media.source &&
          <>
            <Source controls='controls' ref={ videoRef }>
              <source src={ media.source } type='video/mp4' />
            </Source>
            <IconWrapper>
              <Icon
                onClick={ handleClick }
                name='play'
                size={ 30 }
                color={ theme.colors.white }
              />
            </IconWrapper>
          </>}
      </MediaWrapper>
      <ContentWrapper>
        { media.category && media.category.length && <Category>{media.category}</Category> }
        { media.title && media.title.length && <Title>{media.title}</Title> }
        { media.text && media.text.length && <Text>{media.text}</Text> }
      </ContentWrapper>
    </Container>
  )
}

VideoCard.propTypes = {
  media: PropTypes.shape({
    thumb: PropTypes.string,
    thumbAlt: PropTypes.string,
    category: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    source: PropTypes.string
  }).isRequired,
  long: PropTypes.bool,
  gtm: PropTypes.func
}

export default VideoCard
